export default function QuemSomos() {
    return (
        <div className="area-quem-somos">
            <div className="conteudo">
                <h3>Quem Somos</h3>
                <p>Em breve...</p>
            </div>
        </div>
    )
}